var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslateTutorialBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Translate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0672 9.32703H19.1541V7.39502C19.1541 7.21275 19.0769 7.03902 18.9417 6.91682C18.8064 6.79462 18.6257 6.73545 18.4445 6.7538C18.3419 6.7642 16.0431 7.02416 14.8986 9.32703H12.673V1.93282C12.673 0.867068 11.8059 0 10.7402 0H1.93282C0.867066 0 0 0.867068 0 1.93282V10.7402C0 11.806 0.867066 12.673 1.93278 12.673H2.84595V14.605C2.84595 14.7873 2.92312 14.961 3.05834 15.0832C3.17737 15.1908 3.33154 15.2495 3.49044 15.2495C3.51205 15.2495 3.53384 15.2485 3.55554 15.2462C3.65814 15.2358 5.95689 14.9759 7.10136 12.673H9.32697V20.0672C9.32697 21.133 10.194 22 11.2597 22H20.0671C21.1329 22 22 21.133 22 20.0673V11.2599C22 10.1941 21.1329 9.32703 20.0672 9.32703ZM6.68327 11.3839C6.41884 11.3839 6.18123 11.5455 6.08395 11.7913C5.61503 12.9764 4.75123 13.5215 4.13505 13.768V12.0285C4.13505 11.6725 3.84648 11.3839 3.49052 11.3839H1.93282C1.57786 11.3839 1.28911 11.0952 1.28911 10.7402V1.93282C1.28906 1.57786 1.57786 1.28906 1.93282 1.28906H10.7402C11.0952 1.28906 11.3839 1.57786 11.3839 1.93278V10.7402C11.3839 11.0952 11.0951 11.3839 10.7402 11.3839H6.68327V11.3839ZM20.7109 20.0673C20.7109 20.4222 20.4221 20.711 20.0672 20.711H11.2598C10.9048 20.711 10.6161 20.4222 10.6161 20.0673V12.673H10.7402C11.806 12.673 12.673 11.8059 12.673 10.7402V10.6161H15.3167C15.5812 10.6161 15.8188 10.4546 15.9161 10.2087C16.385 9.02367 17.2488 8.47852 17.8649 8.23201V9.97156C17.8649 10.3275 18.1535 10.6161 18.5095 10.6161H20.0672C20.4221 10.6161 20.7109 10.9049 20.7109 11.2598V20.0673H20.7109Z",
    fill: "url(#paint0_linear_1268_930)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.92624 8.27999C8.91804 8.27995 8.12268 8.26839 7.33146 7.86182C7.78418 7.28208 8.14099 6.49545 8.24407 5.42944H8.92358C9.27953 5.42944 9.56811 5.14086 9.56811 4.78491C9.56811 4.42895 9.27953 4.14037 8.92358 4.14037H6.98087V3.75C6.98087 3.39405 6.6923 3.10547 6.33634 3.10547C5.98039 3.10547 5.69181 3.39405 5.69181 3.75V4.14037H3.74907C3.39311 4.14037 3.10454 4.42895 3.10454 4.78491C3.10454 5.14086 3.39311 5.42944 3.74907 5.42944H4.42857C4.5317 6.49545 4.88847 7.28208 5.34119 7.86182C4.54996 8.26839 3.7547 8.2799 3.74902 8.27999C3.39307 8.27999 3.10449 8.56857 3.10449 8.92452C3.10449 9.28048 3.39307 9.56905 3.74902 9.56905C3.79521 9.56905 4.89302 9.56231 5.99277 8.97578C6.10552 8.91563 6.22067 8.84769 6.33626 8.77211C6.45189 8.84769 6.567 8.91567 6.67975 8.97578C7.77949 9.56231 8.8773 9.56905 8.92349 9.56905C9.27944 9.56905 9.56936 9.28048 9.56936 8.92452C9.56936 8.56857 9.2822 8.27999 8.92624 8.27999ZM6.33634 7.0375C6.00974 6.60489 5.80538 6.068 5.72559 5.42944H6.94706C6.86731 6.068 6.66291 6.60489 6.33634 7.0375Z",
    fill: "url(#paint1_linear_1268_930)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.2401 12.7879C16.1309 12.5696 15.9077 12.4316 15.6636 12.4316C15.4194 12.4316 15.1963 12.5696 15.0871 12.7879L12.4998 17.9625C12.3406 18.2809 12.4697 18.668 12.7881 18.8272C12.8806 18.8735 12.9789 18.8954 13.0758 18.8954C13.3122 18.8954 13.5398 18.7648 13.6528 18.539L14.1214 17.6016H17.2056L17.6743 18.539C17.8335 18.8574 18.2206 18.9865 18.539 18.8272C18.8574 18.668 18.9865 18.2809 18.8273 17.9625L16.2401 12.7879ZM14.766 16.3125L15.6636 14.5174L16.5611 16.3125H14.766Z",
    fill: "url(#paint2_linear_1268_930)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.7124 3.68755C15.8382 3.8134 16.0032 3.87635 16.1681 3.87635C16.333 3.87635 16.498 3.81345 16.6238 3.68755C16.8755 3.43584 16.8755 3.02776 16.6238 2.77605L16.4388 2.59103C18.8111 2.73158 20.6981 4.70574 20.6981 7.11268C20.6981 7.46863 20.9867 7.75721 21.3426 7.75721C21.6986 7.75721 21.9872 7.46863 21.9872 7.11268C21.9872 3.99 19.5146 1.4343 16.4245 1.2996L16.6238 1.10027C16.8755 0.848554 16.8755 0.440479 16.6238 0.188767C16.3722 -0.062901 15.964 -0.0629439 15.7123 0.188767L14.4188 1.48243C14.1671 1.73414 14.1671 2.14222 14.4188 2.39393L15.7124 3.68755Z",
    fill: "url(#paint3_linear_1268_930)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.27481 18.3001C6.02314 18.0484 5.61503 18.0484 5.36332 18.3001C5.11161 18.5518 5.11161 18.9599 5.36332 19.2116L5.54834 19.3967C3.17608 19.2561 1.28906 17.2819 1.28906 14.875C1.28906 14.519 1.00048 14.2305 0.644531 14.2305C0.288578 14.2305 0 14.519 0 14.875C0 17.9977 2.47255 20.5534 5.56265 20.6881L5.36332 20.8874C5.11161 21.1391 5.11161 21.5472 5.36332 21.7989C5.48917 21.9248 5.65413 21.9877 5.81904 21.9877C5.98396 21.9877 6.14896 21.9248 6.27477 21.7989L7.56839 20.5052C7.8201 20.2535 7.8201 19.8455 7.56839 19.5938L6.27481 18.3001Z",
    fill: "url(#paint4_linear_1268_930)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1268_930",
    x1: 22,
    y1: 28.0893,
    x2: -1.01057,
    y2: 27.5226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1268_930",
    x1: 9.56936,
    y1: 11.3581,
    x2: 2.80753,
    y2: 11.1915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1268_930",
    x1: 18.8955,
    y1: 20.6845,
    x2: 12.1347,
    y2: 20.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1268_930",
    x1: 21.9872,
    y1: 9.9043,
    x2: 13.8737,
    y2: 9.7045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1268_930",
    x1: 7.75717,
    y1: 24.1348,
    x2: -0.356326,
    y2: 23.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateTutorialBox);
export default __webpack_public_path__ + "static/media/translate-tutorial-box.fc711f7a303f6e0e38fa20cf64df4d92.svg";
export { ForwardRef as ReactComponent };